import React from 'react'
import PageForm from 'components/pageForm/PageForm.js'
import SubNavbar from 'components/SubNavbar/SubNavbar.js'
import BodyVivier from './components/content/body.vivier.js'



function Vivier() {
  return (
    <>
    <PageForm>
        <BodyVivier/>
    </PageForm>
</>
  )
}

export default Vivier